export default __webpack_public_path__ + "ffd61d48001cb0edd7f44d105422008d.svg";